import { useAuthManager } from '@funtech-int/yango-shared';

import { useCurrentUrl } from '@/shared/hooks/useCurrentUrl';

export function useLoginUrl(retpath?: URL) {
    const authManager = useAuthManager();
    const currentUrl = useCurrentUrl();

    return authManager.getLoginUrl(retpath || currentUrl);
}
